import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EquipementPageComponent } from './equipement-page.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";


@NgModule({
  declarations: [EquipementPageComponent],
    imports: [
        CommonModule,
        RouterModule.forChild([{path: '', component: EquipementPageComponent}]),
        ComponentsModule,
        NgbModule,
        FontAwesomeModule
    ]
})
export class EquipementPageModule {
}
